import React, { Component } from "react";
import DeckBuilderAside from "./DeckBuilderComponents/DeckBuilderAside";
import DeckBuilderMain from "./DeckBuilderComponents/DeckBuilderMain";
import novajson from './DeckBuilderComponents/novablitz_full.json';
import _ from 'lodash';
import uniqBy from 'lodash/uniqBy';
import map from 'lodash/map';
import * as firebasedb from "./firebase/firebase";


class DeckBuilder extends Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
      decklist: [],
      deckCount: 0,
      nanoCost: 0,
      decks: [],
      saveform: false,
      deckName: "",
      author: "",
      description: "",
      preview: false,
      previewCard: ""

    }

  this.cardClickHandler = this.cardClickHandler.bind(this);
  this.removecard = this.removecard.bind(this);
  this.stateupdate = this.stateupdate.bind(this);
  this.save = this.save.bind(this);
  //this.load = this.load.bind(this);
  this.deckNameChange = this.deckNameChange.bind(this);
  this.authorChange = this.authorChange.bind(this);
  this.descriptionChange = this.descriptionChange.bind(this);
  this.deckDetailsDisplay = this.deckDetailsDisplay.bind(this);
  this.cardPreview = this.cardPreview.bind(this);

  }


  stateupdate(data){
    this.setState({decklist: data})
  }

  cardClickHandler(event) {
    console.log(event.target.id + " card was clicked")

          var theDeckList = this.state.decklist;
          var firstBy = require('thenby');
          var thenBy = require('thenby');
          var cardId = event.target.id;
          var cardname = "";
          var cardqty = 1;
          var aspectIcon = '';
          var color = '';
          var cardCost = "";
          var rarityIcon = "";
          var oktoAdd = false;
          var increaseDeckCount = false
          var cardNano = 0;
          var nanoCost = 0;

          //functions provided by lodash include
          var includedAspects = _.map(_.uniqBy(theDeckList, 'AspectIcon'), function (item) {
              return {
                  AspectIcon: item.AspectIcon

              };
          });


          if (this.state.deckCount == 60) {
              alert("<strong>Hey!</strong> Decks cannot exceed 60 cards.");
          }
          else {
              var result = _.find(theDeckList, { "CardId": cardId });
              if (result)
              {
                _.forOwn(theDeckList, function(value, key) {
                  if (value.CardId == cardId) {
                      if (value.CardQty < 3) {
                          value.CardQty++;
                          cardNano = value.NanoCost;
                          increaseDeckCount = true;
                      }
                      else { alert("<strong>Hey!</strong> Only three copies of a card allowed!"); };
                  };

                } );
              }
              else {
                  _.forOwn(novajson.Cards, function(value, key) {
                      if (value.CardId == cardId) {
                          cardname = value.Name;
                          cardCost = value.Cost;

                          switch (value.Aspect) {
                              case "C":
                                  aspectIcon = "ChaosIcon2";
                                  break;
                              case "T":
                                  aspectIcon = "TechnologyIcon2";
                                  break;
                              case "A":
                                  aspectIcon = "ArcaneIcon2";
                                  break;
                              case "D":
                                  aspectIcon = "DivineIcon2";
                                  break;
                              case "N":
                                  aspectIcon = "NatureIcon2";
                                  break;
                              default:
                                  aspectIcon = "Unknown";
                          }

                          switch (value.Rarity) {
                              case "C":
                                  rarityIcon = "Rarity_Common.png";
                                  cardNano = 40;
                                  break;
                              case "R":
                                  rarityIcon = "Rarity_Rare.png";
                                  cardNano = 200;
                                  break;
                              case "E":
                                  rarityIcon = "Rarity_Epic.png";
                                  cardNano = 1000;
                                  break;
                              case "L":
                                  rarityIcon = "Rarity_Legendary.png";
                                  cardNano = 4000;
                                  break;
                              default:
                                  aspectIcon = "Unknown";
                          }
                      }
                  })

                   //Check to make sure only 2 aspects are used.
                   if (includedAspects.length > 1) {
                       _.forOwn(includedAspects, function(value, key) {
                          if (value.AspectIcon == aspectIcon) {
                              oktoAdd = true;
                          }
                      });
                  } else { oktoAdd = true; }

                   if (oktoAdd) {
                       theDeckList.push({ 'CardQty': cardqty, 'CardId': cardId, 'CardCost': cardCost, 'CardName': cardname, 'RarityIcon': rarityIcon, 'NanoCost': cardNano, 'AspectIcon': aspectIcon });

                       theDeckList.sort(firstBy("CardCost").thenBy("CardName", { ignoreCase: true }));
                       increaseDeckCount = true;
                   }
                   else { alert("<strong>Hey!</strong> Only two Aspects allowed per deck!"); }
              }
          };

          if (increaseDeckCount)
          {
            this.setState({deckCount: this.state.deckCount + 1})
            this.setState({nanoCost: this.state.nanoCost + cardNano})
            console.log(this.state.nanoCost);
          }
          this.setState({decklist: theDeckList})
  }

  removecard(event) {
      var cardId = event.currentTarget.id;
      var theDeckList = this.state.decklist;
      var C = "";
      var cardNano = 0;

      _.forOwn(theDeckList, function(value, key) {
        if (value.CardId == cardId) {
            cardNano = value.NanoCost;
            if (value.CardQty > 1) {
                value.CardQty--;

            }
            else { C = value.CardId};
        };
      } );

      var updatedDecklist = theDeckList.filter(function (card) {
          return (card.CardId != C);
      });
      this.setState({nanoCost: this.state.nanoCost - cardNano})
      this.setState({deckCount: this.state.deckCount - 1})
      this.setState({decklist: updatedDecklist})
      console.log(this.state.nanoCost);
  };

  cardPreview(card) {
      console.log("this is your card " + card )
      if (this.state.preview) {
        this.setState({preview: false})
      }
      else {
        this.setState({preview: true})
      }

      this.setState({previewCard: card})

  }

  deckDetailsDisplay(event) {
/*
      db.collection("cities").add({
      name: "Tokyo",
      country: "Japan"
      })
      .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
      })
      .catch(function(error) {
          console.error("Error adding document: ", error);
      });
*/
    if (this.state.saveform == false)
    this.setState({saveform: true})
    else {
      this.setState({saveform: false})
    }


/*
      var theDeckList = this.state.decklist;
      firebasedb.db.collection("deckDetails").add({
          cards: theDeckList
      })
      .then(function(docRef) {
          console.log("Document written with ID: ", docRef.id);
      })
      .catch(function(error) {
          console.error("Error adding document: ", error);
      });
*/
  }
/*
  load(event){

          var docRef = firebasedb.db.collection("deckDetails").doc("eeHu6fck0If4BJ680YaN");
          var test = [];
          var the = this;
          docRef.get().then(function(doc) {
              if (doc.exists) {
                var deckDetails = doc.data().cards;
                test = [];
                _.forOwn(deckDetails, function(value, key) {
                  test.push({ 'CardQty': value.CardQty, 'CardId': value.CardId, 'CardCost': value.CardCost, 'CardName': value.CardName, 'RarityIcon': value.RarityIcon, 'AspectIcon': value.AspectIcon });

                } );
                  the.stateupdate(test);
                  console.log("Document data:", doc.data());
              } else {
                  // doc.data() will be undefined in this case
                  console.log("No such document!");
              }
          }).catch(function(error) {
              console.log("Error getting document:", error);
          });

  }
*/

  save(event) {

    var theDeckList = this.state.decklist;
    firebasedb.db.collection("deckDetails").add({
        deckName: this.state.deckName,
        cards: theDeckList,
        author: this.state.author,
        description: this.state.description,
        nanoCost: this.state.nanoCost,
        cardCount: this.state.deckCount
    })
    .then(function(docRef) {
        console.log("Document written with ID: ", docRef.id);
    })
    .catch(function(error) {
        console.error("Error adding document: ", error);
    });

  }
  deckNameChange(event) {
    this.setState({deckName: event.target.value})
  }

  authorChange(event) {
    this.setState({author: event.target.value})
  }

  descriptionChange(event) {
    this.setState({description: event.target.value})
  }



  render() {
    return (
      <React.Fragment>
        <DeckBuilderAside decklist={this.state.decklist} deckcount={this.state.deckCount} clickHandler={this.removecard}
        deckDetailsHandler={this.deckDetailsDisplay} nanoCost={this.state.nanoCost} cardPreview = {this.cardPreview}
        preview={this.state.preview} previewCard={this.state.previewCard} />
        <DeckBuilderMain width="70%" clickHandler={this.cardClickHandler} saveform={this.state.saveform}
           deckNameHandler={this.deckNameChange} authorHandler={this.authorChange} descriptionHandler={this.descriptionChange}
           author={this.state.author} description={this.state.description} deckName={this.state.deckName} deckSave={this.save}/>
      </ React.Fragment>
    );
  }
}

export default DeckBuilder;



// WEBPACK FOOTER //
// ./src/DeckBuilder.js